import Status from 'clarks/components/ivu-table/status'

let exports = {
   addRecipients:{
      forms:[
         {
            type: 'text', form_type: 'email', class: 'col-12', model: 'email',
            validation: 'required|min:3|max:150|email', label: 'Recipient Email', placeholder: 'e.g. johndoe@gmail.com',
         },
      ],
      table:{
         icon: 'fa fa-envelope-open-text',
         title: 'Recipients',
         table_fields: [
            { name: 'Email', align: 'l' },
            { name: 'Actions', align: 'c' }
         ],
         search_fields: ["email",],
         row_data: [
            { type: 'text', field: 'email', class: 'bold' },
            {
               type: 'action', field: 'name', class: 'center', icon: '', actions: [
                  // {type: 'title', title: 'Actions'},
                  { type: 'menu', title: 'View', event: 'table:view' },
                  { type: 'menu', title: 'Delete', event: 'table:delete', icon: 'fa-trash-alt' },
               ]
            },
         ]
      }
   },
}
let forms = {
   addReport: {
      icon: 'fa fa-university',
      title: 'Add Report',
      subtitle: 'Provide Report Details',
      forms: [
         { type: "text", form_type: "text", class: "col-12", validation: "required|min:3|max:250", model: "subject", label: "Subject", },
         {
            type: "select",
            class: "col-12",
            filterable: false,
            clearable: true,
            options: [],
            validation: "required",
            model: "dashboard_id",
            label: "Dashboard",
         },
         {
            type: 'form-table', class: "col-12", forms: exports.addRecipients.forms, table: exports.addRecipients.table, label: 'Recipients', model: 'recipients',
         },
         { type: "text", form_type: "number", class: "col-12", validation: "required|min:1|max:5", model: "days", label: "Days", },
         { type: "checkbox", class: "col-12 custom-check", validation: "", model: "is_recurrent", label: "Is Recurrent", },

      ]
   },
   editReport: {
      icon: 'fa fa-university',
      title: 'Edit Report',
      subtitle: 'Update Report Details',
      forms: [
         { type: "text", form_type: "text", class: "col-12", validation: "required|min:3|max:250", model: "subject", label: "Subject", },
         {
            type: "select",
            class: "col-12",
            filterable: false,
            clearable: true,
            options: [
               { val: "individual", label: "Individual", },
            ],
            validation: "required",
            model: "dashboard_id",
            label: "Dashboard Id",
         },
         {
            type: 'form-table', class: "col-12", forms: exports.addRecipients.forms, table: exports.addRecipients.table, label: 'Recipients', model: 'recipients',
         },
         { type: "text", form_type: "number", class: "col-12", validation: "required|min:1|max:5", model: "days", label: "Days", },
         { type: "checkbox", class: "col-12 custom-check", validation: "", model: "is_recurrent", label: "Is Recurrent", },

      ]
   },
   sendReport: {
      icon: 'fa fa-university',
      title: 'Edit Report',
      subtitle: 'Update Report Details',
      forms: [
         {
            type: 'datepicker', form_type: 'daterange', format: 'dd-MM-yyyy', placement: 'bottom-end', placeholder: 'Select a date',
            model: 'period', label: 'Report Period', class: 'col-12', validation: 'required', start_date: new Date(),
            options: {
               shortcuts: [
                  {
                     text: 'Last week',
                     value () {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        return [start, end];
                     }
                  },
                  {
                     text: '30 Days',
                     value () {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        return [start, end];
                     }
                  },
                  {
                     text: '60 Days',
                     value () {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 60);
                        return [start, end];
                     }
                  },
                  {
                     text: '90 Days',
                     value () {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        return [start, end];
                     }
                  }
               ]
            },
         },
         {
            type: 'form-table', class: "col-12", forms: exports.addRecipients.forms, table: exports.addRecipients.table, label: 'Recipients', model: 'recipients',
         },
      ]
   },
}

let tables = {
   report: {
      props: {
         icon: 'fa fa-database',
         title: 'Report',
         border: true,
         'max-height': 500,
         'show-summary': false,
         search_fields: ['subject', 'dashboard_id', 'days', 'recipients', ],
         columns: [
            { type: 'selection', width: 60, align: 'center' },
            { type: 'index', width: 60, align: 'center' },
            { title: "Subject", key: "subject", },
            { title: "Dashboard Id", key: "dashboard_id", },
            { title: "Days", key: "days", },

            {
               title: "Status",
               key: "status",
               align: 'center',
               width: 180,
               render: (h, params) => {
                  return h(Status, {
                     props: {
                        status: params.row.status
                     }
                  });
               },
               filters: [{
                     label: "Created",
                     value: 1
                  },
                  {
                     label: "Updated",
                     value: 2
                  },
                  {
                     label: "Pending Create Verification",
                     value: 3
                  },
                  {
                     label: "Pending Update Verification",
                     value: 4
                  },
                  {
                     label: "Pending Delete Verification",
                     value: 5
                  }
               ],
               filterMultiple: true,
               filterMethod(value, row) {
                  switch (value) {
                     case 1:
                        return row.status === 'created';
                     case 2:
                        return row.status === 'updated';
                     case 3:
                        return row.status === 'create_pending';
                     case 4:
                        return row.status === 'update_pending';
                     case 5:
                        return row.status === 'delete_pending';
                  }
               }
            },
         ],
         actions: [
            { type: 'menu', title: 'View', event: 'view', allow_multiple: false },
            { type: 'menu', title: 'Edit', event: 'report:edit', icon: 'fa-edit', allow_multiple: false },
            { type: 'menu', title: 'Delete', event: 'report:delete', icon: 'fa-trash-alt', allow_multiple: true },
            { type: 'menu', title: 'Send Report', event: 'report:send', icon: 'fa-paper-plane', allow_multiple: false },
         ]
      },
   },
}

export default {
   forms: utils.generateAllFormData(forms),
   tables
}